export class Week {
    NWeek: number;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/week-model.ts